import React from "react";
import { ICircleComposition } from "../../interfaces/ICircles";
import {
  BgCircles,
  Circle1,
  Circle2,
  Circle3,
  Circle4,
} from "./styles/Circles";

const Circles: React.FC & ICircleComposition = ({ children, ...restProps }) => (
  <BgCircles {...restProps}>{children}</BgCircles>
);

Circles.Circle1 = function CirclesCircle1({ children, ...restProps }) {
  return <Circle1 {...restProps}>{children}</Circle1>;
};

Circles.Circle2 = function CirclesCircle2({ children, ...restProps }) {
  return <Circle2 {...restProps}>{children}</Circle2>;
};

Circles.Circle3 = function CirclesCircle3({ children, ...restProps }) {
  return <Circle3 {...restProps}>{children}</Circle3>;
};

Circles.Circle4 = function CirclesCircle4({ children, ...restProps }) {
  return <Circle4 {...restProps}>{children}</Circle4>;
};

export default Circles;
